import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Plus, Trash2 } from "lucide-react";
import { inr } from "@/lib/proforma";

export function PIAdjustments({ adjustments, onChange }) {
  const set = (i, patch) => onChange(adjustments.map((a, k) => (k === i ? { ...a, ...patch } : a)));
  return (
    <div className="space-y-1.5" data-testid="pi-adjustments">
      {adjustments.map((a, i) => (
        <div key={i} className="flex items-center gap-2" data-testid={`pi-adj-${i}`}>
          <button type="button" onClick={() => set(i, { sign: a.sign >= 0 ? -1 : 1 })}
            className={`h-8 w-8 rounded-md text-sm font-bold border ${a.sign >= 0 ? "border-emerald-300 text-emerald-700 bg-emerald-50" : "border-rose-300 text-rose-700 bg-rose-50"}`}
            title="Toggle add / less" data-testid={`pi-adj-sign-${i}`}>{a.sign >= 0 ? "+" : "−"}</button>
          <Input value={a.label} onChange={(e) => set(i, { label: e.target.value })} className="h-8 flex-1 text-sm" data-testid={`pi-adj-label-${i}`} />
          <Input type="number" step="any" value={a.amount} onChange={(e) => set(i, { amount: e.target.value === "" ? "" : Number(e.target.value) })}
            className="h-8 w-40 text-right tabular-nums text-sm" data-testid={`pi-adj-amount-${i}`} />
          <span className="w-36 text-right text-xs tabular-nums text-slate-500">{a.sign >= 0 ? "" : "−"}{inr(a.amount)}</span>
          <Button size="icon" variant="ghost" className="h-8 w-8 text-slate-400 hover:text-rose-600" onClick={() => onChange(adjustments.filter((_, k) => k !== i))}
            data-testid={`pi-adj-del-${i}`}><Trash2 className="h-4 w-4" /></Button>
        </div>
      ))}
      <Button size="sm" variant="outline" onClick={() => onChange([...adjustments, { kind: "other", label: "LESS : ", amount: 0, sign: -1 }])} data-testid="pi-adj-add">
        <Plus className="h-4 w-4 mr-1" />Add line
      </Button>
    </div>
  );
}
